import React, { Component, useEffect, useState } from 'react';
import HtmlViewer from '../libs/HtmlViewer';
import PopUp from '../Common/PopUp';
import { useSelector } from 'react-redux';

const Post = (props) => {
    const LoginStates = useSelector(state => state.login);
    const [morePopUp, setMorePopUp] = useState(null);
    const [state, setState] = useState({
        activate: props.activate,
        viewCount: props.postdata.viewcount,
        originalViewCount: props.postdata.viewcount
    });
    
    useEffect(() => {
        if (props.isAccessFromHome) {
            postViewAdd();
        }
    }, []);

    const postViewAdd = () => {
        const input = {
            userId: '',
            userName: '',
            workingTag: 'postViewAdd',
            pageNo: 1,
            postInfo: {
                contentType: '',
                postSeq: props.postdata.postSeq,
                attachSeq: 0,
                commentSeq: 0,
                postData: {
                    title: '',
                    content: '',
                    attachment: [],
                    comment: ''
                }
            }
        };
        fetch('api/Document/NewsManage', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(input)
        }).then((response) => response.json())
            .then((data) => {
                setState(prev => { return { ...prev, viewCount: data.postData }});
            });
        
    };

    const clickPostNode = e => {
        props.clickPostNode(e, state.activate);
        if (props.activate == false) {
            postViewAdd();
        }
    };

    const newlineMaker = (contents) => {
        let strcontent = '';
        contents.split('<br>').map(line => {
            strcontent += '<span>' + line + '<br /></span>';
        });
        return (
            <p className="txt" dangerouslySetInnerHTML={{ __html: strcontent }}>
            </p>
        );
    };

    const attechFile = () => {
        let filenode = [], index = 0;
        const filelist = props.postdata.attachfiles;
        for (var i = 0; i < filelist.length; i++) {            
            filenode.push(
                <li key={index++}>
                    <a href={'/FileServer/UploadFiles/' + filelist[i].attachfilename} target="_blank" rel="noreferrer" download>
                        <div class="img_filename">
                            <i className='icoKdc24 download'></i>
                            <p className="filename">{filelist[i].attachfilename}</p>
                        </div>
                        <p className="filesize">{filelist[i].attachfilesize}</p>
                    </a>
                </li>
            );
        }
        return filelist.length > 0 && (
            <ul className="attached-files">
                {filenode}
            </ul>
        );
    };

    const postDelete = (e) => {
        const isDelete = window.confirm("삭제하시겠습니까?");
        if(isDelete) {
            const input = {
                userId: LoginStates.userId,
                userName: '',
                workingTag: 'postDelete',
                pageNo: 1,
                postInfo: {
                    contentType: '',
                    postSeq: props.postdata.postSeq,
                    attachSeq: 0,
                    commentSeq: 0,
                    postData: {
                        title: '',
                        content: '',
                        attachment: [],
                        comment: ''
                    }
                }
            };
            props.executeFetch(input);
        }
        setMorePopUp(null);
    }

    const MoreButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setMorePopUp(
            <div className="layer-list" style={{
                left: e.clientX + "px",
                top: e.clientY + "px",
                width: "fit-content"                
            }}>
                <div className="context-menu">
                    <ul>
                        <li><a onClick={e => props.setSelectedPost(props.postdata)}>수정</a></li>
                        <li className="delete-doc"><a onClick={postDelete}>삭제</a></li>
                    </ul>
                </div>
            </div>
        );
    }

    if (state.originalViewCount != props.postdata.viewcount) {
        setState(prev => { return {
            ...prev,
            originalViewCount: props.postdata.viewcount,
            viewCount: props.postdata.viewcount
        }});
    }
    return (
        <div className="post-wrap" onClick={clickPostNode}>
            <div class="post-top">
                <div class="post-cate-title">
                    <p className='post-cate'>{props.postdata.category}</p>
                    <a className="title">{props.postdata.posttitle}</a>
                </div>
                {LoginStates.admin && <button onClick={MoreButtonClick}><i className='icoKdc32 kebab'></i></button>}
                <PopUp content={morePopUp} setContent={setMorePopUp} />
            </div>
            <div class="post-info">
                <div className="info">
                    <span className="writer">{props.postdata.writer}</span>
                    <span className="timestamp">{props.postdata.timestamp}</span>
                </div>
                <div className="stats">
                    <span className="views">조회수 {state.originalViewCount != props.postdata.viewcount ? props.postdata.viewcount : state.viewCount}</span>
                </div>
            </div>
            <div className="post-content" style={{display: props.activate ? "" : "none"}} onClick={e => e.stopPropagation()}>
                <HtmlViewer data={props.postdata.postcontent} className={"txt"} />
                {attechFile()}
            </div>
        </div>
    );
}
export default Post;